// extracted by mini-css-extract-plugin
module.exports = {"themes":"#a32126"};